module.exports = __webpack_public_path__ + "static/media/MacPro_Dashboard_small.50b0e009.png";